import { ref } from 'vue';
import apiClient from '@/composables/common/axios';

const notifications = ref([]);
const unreadCount = ref(0);

export const useNotifications = () => {
  const fetchNotifications = async (limit = 50, offset = 0) => {
    try {
      const response = await apiClient.get('/api/notifications.php', {
        params: {
          action: 'list',
          limit,
          offset
        }
      });

      if (response.data.success) {
        notifications.value = response.data.notifications;
        return { success: true, notifications: response.data.notifications };
      }
      return { success: false, message: response.data.message };
    } catch (error) {
      // console.error('[Notifications] Fetch error:', error);
      return { success: false, message: '알림 조회 실패' };
    }
  };

  const fetchUnreadCount = async () => {
    try {
      const response = await apiClient.get('/api/notifications.php', {
        params: { action: 'unread_count' }
      });

      if (response.data.success) {
        unreadCount.value = response.data.count;
        return response.data.count;
      }
      return 0;
    } catch (error) {
      // console.error('[Notifications] Unread count error:', error);
      return 0;
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      const response = await apiClient.post('/api/notifications.php?action=mark_read', {
        notification_id: notificationId
      });

      if (response.data.success) {
        // 로컬 상태 업데이트
        const notification = notifications.value.find(n => n.id === notificationId);
        if (notification) {
          notification.is_read = 1;
          notification.is_new = false;
        }
        await fetchUnreadCount();
        return { success: true };
      }
      return { success: false, message: response.data.message };
    } catch (error) {
      // console.error('[Notifications] Mark read error:', error);
      return { success: false, message: '읽음 처리 실패' };
    }
  };

  const markAllAsRead = async () => {
    try {
      const response = await apiClient.post('/api/notifications.php?action=mark_all_read');

      if (response.data.success) {
        // 로컬 상태 업데이트
        notifications.value.forEach(n => {
          n.is_read = 1;
          n.is_new = false;
        });
        unreadCount.value = 0;
        return { success: true };
      }
      return { success: false, message: response.data.message };
    } catch (error) {
      // console.error('[Notifications] Mark all read error:', error);
      return { success: false, message: '읽음 처리 실패' };
    }
  };

  return {
    notifications,
    unreadCount,
    fetchNotifications,
    fetchUnreadCount,
    markAsRead,
    markAllAsRead
  };
};
